<div class="base-avatar" [ngClass]="avatarClasses()">
  {{ firstName?.charAt(0) }}{{ lastName?.charAt(0) }}
</div>
